import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20coral%20and%20cream%20tones%2C%20modern%20minimal%20design%20with%20gentle%20curves%20and%20floating%20geometric%20elements%2C%20dreamy%20atmospheric%20light%20with%20subtle%20particles%2C%20digital%20art%20style%2C%20warm%20cinematic%20color%20grading%2C%20abstract%20fluid%20forms%20reminiscent%20of%20creative%20energy%20flowing&width=1800&height=900&seq=hero-bg-kuaimao&orientation=landscape"
          alt="快猫平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            快猫——让每一份创作<span className="text-primary-400">闪闪发光</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            汇聚海量优质创作者与精彩内容的内容创作平台。
            智能创作工具、多元变现体系、AI创作助手，助你从零到一开启创作之旅。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/short-video"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始创作
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-md border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="mt-10 flex items-center justify-center gap-8 text-white/60 text-sm">
            <div className="text-center">
              <div className="text-2xl font-bold text-white">1000万+</div>
              <div className="text-xs mt-1">活跃创作者</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">5亿+</div>
              <div className="text-xs mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">50亿+</div>
              <div className="text-xs mt-1">日均播放量</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}